'use strict';
const angular = require('angular');

/*@ngInject*/
export function CustomEntityService($resource) {
  return $resource('/api/custom-entities/:id', {
    name: '@_id'
  },{
    getByType: {
      method: 'GET',
      isArray: true,
      url: "/api/custom-entities/type/:type"
    },
    getCustomList: {
      method: 'GET',
      isArray: true,
      url: "/api/custom-entities/:type/list-by/:refField/:refId"
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
    method: 'PUT',
      url: "/api/custom-entities/:id/attachments"
  }
  });
}


export default angular.module('conduu.CustomEntityService', [])
  .factory('CustomEntityService', CustomEntityService)
  .name;



// WEBPACK FOOTER //
// ./client/components/custom-entity/custom-entity.service.js